import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { setFuseauUsine } from "@/lib/format";

/** Fuseau de l'usine fourni par le serveur : « aujourd'hui » (todayIso) en dépend. Les pages ne s'affichent qu'une fois
 *  le fuseau connu (succès ou échec : en cas d'échec on retombe sur le fuseau du navigateur, jamais de blocage).
 *  Utilisé par AppLayout ET par le mur d'écrans (/mur, hors AppLayout). */
export const FuseauGate = ({ children }) => {
  const { user, entrepriseId } = useAuth();
  const enabled = user?.role !== "superadmin" || !!entrepriseId;
  const q = useQuery({ queryKey: ["fuseau-usine", entrepriseId], enabled, staleTime: 5 * 60000, retry: 1, queryFn: () => get("/fuseau-usine") });
  setFuseauUsine(q.data?.fuseau_horaire);
  return !enabled || !q.isLoading ? children : null;
};
